import { readonly, shallowRef } from 'vue';

const currentView = shallowRef(null);

export function useExportContext() {
  const setView = (view) => { currentView.value = view; };
  return { currentView: readonly(currentView), setView };
}
